<script lang="ts" setup></script>

<template>
  <m-section class="bg-text-light">
    <div
      class="border-primary text-text-dark flex min-h-[508px] max-w-screen-xl flex-col space-y-7 space-x-0 overflow-hidden rounded-3xl border-[3px] md:flex-row md:space-y-0 md:space-x-7"
    >
      <div class="p-8">
        <section-heading :title="$t('app.homePage.aboutUs.title')"></section-heading>
        <div class="mb-8 space-y-4 leading-[150%] md:text-xl">
          <p v-html="$t('app.homePage.aboutUs.p1')"></p>
          <p>
            {{ $t("app.homePage.aboutUs.p2") }}
          </p>
        </div>
        <base-button :text="$t('app.homePage.aboutUs.btnLabel')" route-name="ContactPage"></base-button>
      </div>
      <div
        class="h-[358px] bg-[url('@/assets/image/aboutUs/upoznajte-nas-slika.jpg')] bg-cover bg-center bg-no-repeat md:h-[100%] md:w-[50%] md:min-w-[50%]"
      ></div>
    </div>
  </m-section>
</template>
